import Axios from '@/utils/axios';
import Api from '@/constant/api';

export const getList = async (params) => {
  return Axios.jsonGet(Api.order.order_list, { params });
};

export const getDetail = async (params) => {
  return Axios.jsonGet(Api.order.order, { params });
};

export const shippingInfo = async (params) => {
  return Axios.jsonGet(Api.order.shipping_info, { params });
};

export const shipCompany = async (params) => {
  return Axios.jsonGet(Api.order.ship_company, { params });
};

export const ship = async (params) => {
  return Axios.jsonPost(Api.order.ship, params);
};

export const getAddressList = async (params) => {
  return Axios.jsonGet(Api.order.address_list, { params });
};

export const setAddress = async (params) => {
  return Axios.jsonPost(Api.order.address, params);
};

export const restock = async (params) => {
  return Axios.jsonPost(Api.order.restock, params);
};

export const getRestockList = async (params) => {
  return Axios.jsonGet(Api.order.restock_list, { params });
};

export const restockShip = async (params) => {
  return Axios.jsonPost(Api.order.restock_ship, params);
};

export const confirmRestockOrder = async (params) => {
  return Axios.jsonPost(Api.order.confirm_restock_order, params);
};
